import React, { useEffect, useContext, useState } from 'react'
import styled from 'styled-components'
import Contact from './Contact'
import bannerImg from '../../assets/contact_info_1.svg'
import { AppContext } from '../../App'

const BannerImg = styled.img.attrs(() => ({
  src: bannerImg
}))`
  width : 806.11px;
  height: 484px;
  @media (min-width: 901px) and (max-width: 1349px){
    width: 151%;
   };
  }
  `

const BannerTab = styled.img.attrs(() => ({
  src: bannerImg
}))`

  display: none;

  @media (min-width: 601px) and (max-width: 900px){
    display: flex;
    width: 69%;
    height: 43%;
    position: absolute;
    top: 68%;
    left: 6%;
   };

   @media (min-width: 0px) and (max-width: 600px){
    display: flex;
    width: 127%;
    margin-left: 189px;
    height: 43%;
   };
  }
  `

const Main = styled.div`
    background : #25233B;
    display: flex;
    height: 100vh;
    justify-content: space-between;
    padding-top: 87px;
    width: 1296px;
    margin: auto;
    overflow: hidden;
    @media (min-width: 901px) and (max-width: 1349px){
        width: 96%;
        padding: 87px 20px;
        height: calc(100vh - 269px);

    };
    @media (min-width: 0px) and (max-width: 900px){
        flex-direction: column;
        width: 100%;
        align-items: center;
        margin: auto;
        padding-top: 0px;

    }
`
const LeftPane = styled.div`
    width : 50%;
    @media (min-width: 0px) and (max-width: 900px){
        display: none
    }
`

const TitleDiv = styled.span`
    width: 623px;
    text-align: left;
    color: #FFFFFF;
    @media (min-width: 901px) and (max-width: 1349px){
        width: 100%;
    };
    @media (min-width: 0px) and (max-width: 900px){
        display: none
    }
`

const Title = styled.div`
    font-family: "AeonikPro-Regular";
    font-style: normal;
    font-weight: 600;
    font-size: 48px;
    line-height: 72px;
    letter-spacing: -4%
    z-index:100;
`
const ContactDiv = styled.div`
    margin: 0 auto;
    background: white;
    height: fit-content;
    border-radius: 8px;
    @media (min-width: 601px) and (max-width: 900px){
        width: fit-content;
        z-index: 1;
    }
    @media (min-width: 0px) and (max-width: 600px){
        width: 80%;
        height: 685px;
    }
`

const GetInTouch = () => {
  const { setShowSearch } = useContext(AppContext)
  const [hideBanner, setHideBanner] = useState(false)

  useEffect(() => {
    setShowSearch(true)
    document.title = 'Marketplace'
  }, [])

  const handleClose = () => {
    setHideBanner(true)
  }

  return (
      <Main>
           {!hideBanner && <LeftPane>
                <TitleDiv >
                    <Title > Digital adoption made&nbsp;<span style={{ color: '#f4a250' }}>simple</span>  </Title>
                </TitleDiv>
                <BannerImg />
            </LeftPane>}
            <ContactDiv>
                <Contact appId={undefined} open={false} handleClose={handleClose} appName={undefined} />
            </ContactDiv>
            <BannerTab />
      </Main>
  )
}

export default GetInTouch
